import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from 'axios';


const Leave = ({ show, onClose, onSubmit, staffId, staffOptions= [], existingData = {} }) => {
    const staff = staffOptions.find((s) => s.id === staffId) || { name: 'Unknown', department: '-' };
    // console.log('staffId:', staffId);
    // console.log('staffOptions:', staffOptions);

    // State for form inputs
    const [dates, setDates] = useState([]);
    const [leaveType, setLeaveType] = useState(null);
    const [reason, setReason] = useState('');
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [errors, setErrors] = useState({
        dates: '',
        leaveType: '',
        reason: '',
    });
    // Date format
    const format = 'MM/DD/YYYY';

    // Fetch leave types from API
    useEffect(() => {
        axios
        .get(`${baseURL}/manage-leavetype`)
        .then((response) => {
            if (response.data.message === 'Leave Types fetched successfully') {
            // Map API response to react-select format
            const options = response.data.data.map((type) => ({
                value: type.sno, // Use leadtype_id as value
                label: type.leavetype_name, // Use leadtype_name as label
            }));
            setLeaveTypeOptions(options);
            }
        })
        .catch((error) => {
            console.error('Error fetching leave types:', error);
            // swal.fire('Error', 'Failed to fetch leave types.', 'error');
        });
    }, [baseURL]);

    // const handleDatesChange = (selectedDates) => {
    //     // If user selected 2 dates, expand all dates between them
    //     if (selectedDates.length === 2) {
    //         const start = selectedDates[0].toDate();
    //         const end = selectedDates[1].toDate();
    //         const allDates = [];
    //         for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    //         allDates.push(new DateObject(new Date(d)));
    //         }
    //         setDates(allDates);
    //     } else {
    //         setDates(selectedDates);
    //     }
    //     };

    // const handleDatesChange = (selectedDates) => {
    //     console.log('handleDatesChange called with:', selectedDates);
    //     setDates(selectedDates);
    // };

    // useEffect(() => {
    //     console.log('Dates state updated:', dates);
    // }, [dates]);

    // useEffect(() => {
    //     if (existingData && show) {
    //         // Convert dates if they exist
    //         if (existingData.start_date || existingData.dates) {
    //             const start = existingData.start_date || existingData.dates?.[0];
    //             const end = existingData.end_date || existingData.dates?.[1] || start;

    //             setDates([new DateObject(start), new DateObject(end)]);
    //         }

    //         if (existingData.leave_type) {
    //             setLeaveType({
    //                 value: existingData.leave_type,
    //                 label: leaveTypeOptions.find(opt => opt.value === existingData.leave_type)?.label || 'Leave Type'
    //             });
    //         }

    //         if (existingData.reason) {
    //             setReason(existingData.reason);
    //         }
    //     }
    // }, [existingData, show, leaveTypeOptions]);

    const [initialized, setInitialized] = useState(false);

    // useEffect(() => {
    //     if (existingData && show && !initialized) {
    //         if (existingData.dates && Array.isArray(existingData.dates)) {
    //         const allDates = existingData.dates.map(date => new DateObject(date));
    //         setDates(allDates);
    //         } else if (existingData.start_date) {
    //         const start = existingData.start_date;
    //         const end = existingData.end_date || start;
    //         setDates([new DateObject(start), new DateObject(end)]);
    //         }
            
    //         if (existingData.leave_type) {
    //         setLeaveType({
    //             value: existingData.leave_type,
    //             label: leaveTypeOptions.find(opt => opt.value === existingData.leave_type)?.label || 'Leave Type',
    //         });
    //         }

    //         if (existingData.reason) {
    //         setReason(existingData.reason);
    //         }
            
    //         setInitialized(true); // mark initialization done
    //     }

    //     if (!show) {
    //         setInitialized(false); // reset on close
    //     }
    // }, [existingData, show, leaveTypeOptions, initialized]);

    useEffect(() => {
        if (existingData && show && !initialized) {
            // Handle dates
            if (existingData.dates && Array.isArray(existingData.dates)) {
                const formattedDates = existingData.dates.map(date => new DateObject({ date: new Date(date), format }));
                setDates(formattedDates);
            } else if (existingData.start_date) {
                const start = new DateObject({ date: new Date(existingData.start_date), format });
                const end = existingData.end_date ? new DateObject({ date: new Date(existingData.end_date), format }) : start;
                setDates([start, end]);
            }

            // Handle leave type
            if (existingData.leave_type) {
                const option = leaveTypeOptions.find(opt => opt.value === existingData.leave_type);
                if (option) {
                    setLeaveType(option);
                }
            }

            // Handle reason
            if (existingData.reason) {
                setReason(existingData.reason);
            }

            setInitialized(true);
        }

        if (!show) {
            setDates([]);
            setLeaveType(null);
            setReason('');
            setErrors({ dates: '', leaveType: '', reason: '' });
            setInitialized(false);
        }
    }, [existingData, show, leaveTypeOptions, initialized, format]);

    const handleDatesChange = (selectedDates) => {
        setDates(selectedDates);
        setErrors(prev => ({ ...prev, dates: '' }));
    };

    useEffect(() => {
        console.log("Current dates state:", dates);
    }, [dates]);

    const validateForm = () => {
        const newErrors = {
            dates: '',
            leaveType: '',
            reason: '',
        };
        let isValid = true;

        if (!dates.length) {
            newErrors.dates = 'This Field is Required';
            isValid = false;
        }
        if (!leaveType) {
            newErrors.leaveType = 'This Field is Required';
            isValid = false;
        }
        if (!reason.trim()) {
            newErrors.reason = 'This Field is Required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    

        // Handle form submission
    const handleSubmit = () => {
        if (!validateForm()) {
            return;
        }

        // Structure the data as expected by the parent component
        const attendanceData = {
            attendance_type: 1,
            dates: dates.map(d => new DateObject(d).format('YYYY-MM-DD')), // all selected dates as array of strings
            leave_type: leaveType?.value,
            reason: reason || '',
        };
        // console.log(attendanceData);
        // Pass the data to the parent component
        onSubmit(attendanceData);
        onClose(); // Close the modal
    };


    const [selectedOption, setSelectedOption] = useState(null);
    const [isFocused] = useState(false);

    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Mark Leave Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker multiple
                                    format={format}
                                    placeholder='Select Date'
                                    className="date-picker-wrapper"
                                    plugins={[<DatePanel />]}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <Select placeholder='Select Department'
                                onChange={setSelectedOption}
                                options={department}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                isMulti
                                onChange={setSelectedOption}
                                options={staff}
                            />
                        </div> */}
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Staff</label>
                            <label className='text-black fs-6 font-w500'>{staff.name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Department</label>
                            <label className='text-black fs-6 font-w500'>{staff.department}</label>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker multiple
                                    format={format}
                                    placeholder='Select Date'
                                    className="date-picker-wrapper"
                                    plugins={[<DatePanel />]}
                                    value={dates}
                                    onChange={handleDatesChange}
                                    minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    mapDays={({ date }) => {
                                        const day = date.weekDay.index; // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                                        if (day === 0) {
                                        return {
                                            disabled: true,
                                            style: { color: "#ccc", textDecoration: "line-through" }, // Optional styling
                                        };
                                        }
                                    }}
                                />
                            </div>
                            {errors.dates && <span className="text-danger fs-7">{errors.dates}</span>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Leave Type<span className="required">*</span></label>
                            <Select placeholder='Select Leave Type'
                                onChange={setLeaveType}
                                options={leaveTypeOptions}
                                value={leaveType}
                            />
                            {errors.leaveType && <span className="text-danger fs-7">{errors.leaveType}</span>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                            <textarea rows={3} className="h-auto form-control" name="comment" placeholder="Reason" value={reason}
                            onChange={(e) => setReason(e.target.value)} />
                        </div>
                        {errors.reason && <span className="text-danger fs-7">{errors.reason}</span>}
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <button type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Mark Leave Attendance</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Leave;
